export default __webpack_public_path__ + "static/media/adaptive-logo.296da2bd.svg";